<p-select
  filterBy="label, value"
  [options]="options"
  [(ngModel)]="filterValue"
  placeholder="All quotes"
  (onChange)="onChange($event)"
>
  <ng-template #selectedItem>
    @if (filterValue) {
      <p-chip
        [label]="getFilterLabel(filterValue)"
        [removable]="true"
        removeIcon="pi pi-times"
        (onRemove)="clearFilter()"
      />
    }
  </ng-template>
</p-select>
